import { render } from "./CustomisationColorButton.vue?vue&type=template&id=9f2a3704&scoped=true"
import script from "./CustomisationColorButton.vue?vue&type=script&lang=js"
export * from "./CustomisationColorButton.vue?vue&type=script&lang=js"

import "./CustomisationColorButton.vue?vue&type=style&index=0&id=9f2a3704&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2a3704"]])

export default __exports__